import httpRequest from 'httpRequest'
import {
    ServiceChargeSettingContract,
    ServiceChargeSettingDetailContract,
} from 'models'

const SERVICE_CHARGE_SETTING = '/location/service-charge-setting'

const ServiceChargeSettingService = {
    getServiceChargeSetting() {
        return httpRequest.get<ServiceChargeSettingContract>(
            SERVICE_CHARGE_SETTING,
        )
    },
    getServiceChargeSettingDetail() {
        return httpRequest.get<ServiceChargeSettingDetailContract>(
            SERVICE_CHARGE_SETTING + '/with-operational-setting',
        )
    },
    updateServiceChargeSetting(
        serviceChargeId: string,
        body: ServiceChargeSettingDetailContract,
    ) {
        return httpRequest.put(
            `${SERVICE_CHARGE_SETTING}/${serviceChargeId}`,
            body,
        )
    },
}

export default ServiceChargeSettingService
